const get = require('lodash/get')

module.exports.isLocationBelowLevel = (location, level) => get(location, 'additionalData.level', '0') < level
